import { useAnmRedirect } from 'hooks/useAnmRedirect';
import { useEffect } from 'react';

const AnmRedirect = () => {
  const { redirectToAnm } = useAnmRedirect();

  useEffect(() => {
    redirectToAnm();
  }, []);

  return null;
};

export default AnmRedirect;
